import { createFileRoute } from '@tanstack/react-router';
import { CampaignExperimentsRoute } from './-route-wrappers';

function CampaignTestsRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignExperimentsRoute campaignId={campaignId} campaignPath="automations" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/')(
  {
    component: CampaignTestsRoute,
  },
);
